import { useTranslation } from "react-i18next";
import "../TermsPages/terms.css";
import NewLayout from "../layout/newLayout";

const BEChainInstruction = () => {
  const { t } = useTranslation();
  return (
    <NewLayout>
      <div className="terms-pages">
        <div className="container">
          <h2>
            {t("Explanation for pharmacists in private pharmacies / BE chain")}
          </h2>
          <div className="terms-grid">
            <h3>
              {t("You can show the pharmacist the following explanation")}
            </h3>
            <ol>
              <li>{t("Enter D in card field")}</li>
              <li>{t("Enter id or passport")}</li>
              <li>{t("In the hospital selection popup")}</li>
              <li>{t("Select the desired items and continue")}</li>
            </ol>
            <p>{t("The software will print automatically")}</p>
          </div>
        </div>
      </div>
    </NewLayout>
  );
};

export default BEChainInstruction;
